import React, { useState } from "react";
import styles from "./purchaseOrderTable.module.css";
export const PurchaseOrderTable = ({ tableData, total, billId, poId }) => {
  const [show, setShow] = useState(true);

  return (
    <>
      <div className={styles.basicInfoDivPOTblCard}>
        <div className={styles.BasicInfoTopPOTblCard}>
          <div className={styles.basicInfoTopImgPOTblCard}>
            <div>
              <img src="./images/stratum/item.svg" alt="" />
            </div>
            <h6>Items</h6>
          </div>

          <img
            src="/images/upArrow.png"
            className={!show ? styles.rotateSvg : ""}
            alt=""
            onClick={() => setShow(!show)}
          />
        </div>
        {show && (
          <div
            className={styles.basicDetailsDivPoColumDiv}
            id={styles.basicDetailsDivPoColumDivimp}
          >
            <table className={styles.potable}>
              <tbody>
                <tr className={styles.potableHead}>
                  <th>DESCRIPTION</th>
                  {(billId && poId) && <th>EXPENSE CATEGORY</th>}
                  <th>UOM</th>
                  <th className="numberRightAlign">Qty</th>
                  <th className="numberRightAlign">UNIT PRICE</th>
                  <th className="numberRightAlign">DISCOUNT</th>
                  <th className="numberRightAlign">TOTAL UNIT PRICE</th>
                  <th className="numberRightAlign">Vat (%)</th>
                  <th className="numberRightAlign lastColumAlign">
                    Total AMOUNT
                  </th>
                </tr>
                {tableData &&
                  tableData.map((e, i) => {
                    return (
                      <tr key={i} className={styles.potablData}>
                        <td>{e.item}</td>
                        {(billId && poId) && <td >{e.account_name}</td>}
                        <td>{e.uom_name}</td>
                        <td className="numberRightAlign">{e.quantity}</td>
                        <td className="numberRightAlign">{e.unit_price}</td>
                        <td className="numberRightAlign">
                          {parseFloat(e.discount_amount)?.toFixed(2)}
                        </td>
                        <td className="numberRightAlign">
                          {(
                            e.unit_price * e.quantity -
                            parseFloat(e.discount_amount)
                          )?.toFixed(2)}
                        </td>
                        <td className="numberRightAlign">
                          {e.tax || e?.vat_percentages}
                        </td>
                        <td className="numberRightAlign lastColumAlign">
                          {billId ?  e?.total_amount : e?.amount}
                        </td>
                      </tr>
                    );
                  })}
                <tr className={styles.potablData}>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>

                  <td
                    colSpan={(billId && poId) ? 4 :  3}
                    id={styles.grandTotalDiv}
                    className="numberRightAlign"
                  >
                    Grand Total (AED)
                  </td>

                  <td
                    className="numberRightAlign lastColumAlign"
                    id={styles.grandTotalDivval}
                  >
                    {total?.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};
